import clientEvents from '@/../config/clientEvents'
import _ from 'lodash'

const subscribers = {}

export default {
    on: (eventName, handler) => {
        if (clientEvents[eventName]) {
            if (!subscribers[eventName]) {
                subscribers[eventName] = []
            }
            const id = _.uniqueId('EventBusHandler_')
            subscribers[eventName].push({
                id: id,
                handler: handler,
            })

            return id
        } else {
            // eslint-disable-next-line no-throw-literal
            throw (`Event bus doesn't support event '${eventName}'.`)
        }
    },
    emit: (eventName, payload) => {
        if (subscribers[eventName]) {
            subscribers[eventName].forEach((i) => {
                i.handler(payload)
            })
        }
    },
    off: (eventName, handlerId) => {
        const index = _.findIndex(subscribers[eventName], function (i) {
            return i.id === handlerId
        })
        subscribers[eventName] = _.slice(index, 1)
    },
}
